<template>
  <v-expansion-panels flat>
    <v-expansion-panel @click.stop>
      <v-expansion-panel-header style="padding: 0; padding-right: 16px">
        <v-list-item @click="clickHandler">
          <v-list-item-icon v-if="icon" class="mr-2">
            <v-icon :size="20">{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title :style="listItemStyles" class="mr-2">{{
            title
          }}</v-list-item-title>
        </v-list-item>
      </v-expansion-panel-header>

      <v-expansion-panel-content class="multi-menu-item-panel-content">
        <v-list dense>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            @click="itemClickHandler(item)"
          >
            <v-list-item-icon v-if="item.icon" class="mr-2">
              <v-icon :size="20">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import THEME from "constants/theme"
import { SingleMenuItem } from "app/ui-primitives/menus/popup-menu/PopupMenu.vue"

export default defineComponent({
  name: "MultiMenuItem",
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array as () => SingleMenuItem[],
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    clickHandler: {
      type: Function,
      required: false,
      default: () => {
        //pass
      },
    },
    path: {
      type: String,
      required: false,
    },
  },
  setup(props) {
    const { fontFamily, fontWeightRegular, rootFontSize } = THEME.typography
    const { textColor } = THEME.colors.light

    const itemClickHandler = (item: SingleMenuItem) => () => {
      if (item.path) {
        window.location.href = item.path
      } else {
        item.clickHandler?.()
      }
    }

    return {
      itemClickHandler,
      listItemStyles: {
        fontFamily,
        fontSize: `${0.9 * rootFontSize}px`,
        fontWeight: fontWeightRegular,
        color: textColor,
      },
    }
  },
})
</script>

<style>
.multi-menu-item-panel-content .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>
